import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { money } from "@/lib/booking";
import { useI18n } from "@/lib/i18n";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function StaysPage() {
  const { t, pick } = useI18n();
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/properties").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => setList([]));
  }, []);
  return (
    <div className="site min-h-screen bg-paper" data-testid="stays-page">
      <Header showStays />
      <main className="mx-auto max-w-[1280px] px-5 pb-24 pt-32 sm:px-8">
        <Overline>Sámara · Guanacaste</Overline>
        <h1 className="mt-4 font-display text-5xl tracking-tight text-ink sm:text-6xl lg:text-7xl">{t("st.title")}</h1>
        <p className="mt-3 text-muted2">{t("st.sub")}</p>
        <div className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <Link to={`/stay/${p.slug}`} data-testid={`stay-card-${p.slug}`} className="group block">
                <div className="aspect-[4/5] overflow-hidden rounded-[24px] bg-[#E8D8C3]">
                  {p.photos?.[0] && <img src={imgUrl(p.photos[0].url)} alt={p.name} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />}
                </div>
                <div className="mt-4 flex items-start justify-between gap-3">
                  <div>
                    <p className="font-display text-2xl text-ink">{p.name}</p>
                    <p className="line-clamp-1 text-sm text-muted2">{pick(p.title)}</p>
                  </div>
                  {p.rating > 0 && <span className="flex items-center gap-1 text-sm"><Star className="h-3.5 w-3.5 fill-ink" />{p.rating}</span>}
                </div>
                <p className="mt-2 text-sm"><span className="font-semibold">{money(p.price_per_night)}</span> / {t("w.night")}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
